import { Component, Input, OnInit } from "@angular/core";

import { MatDialog, MatSnackBar } from "@angular/material";
import { Estudo } from "../estudo/estudo";
import { EstudoService } from "../estudo/estudo.service";
import { EstudoRenovacaoDialogComponent } from "./estudo-renovacao-dialog.component";
import { EstudoRenovacaoService } from "./estudo-renovacao.service";
import { EstudoRenovacao } from "./estudo-renovacao";

@Component({
  templateUrl: "./estudo-renovacao-button.component.html",
  selector: "estudo-renovacao-button"
})
export class EstudoRenovacaoButtonComponent implements OnInit {
  @Input() idEstudo: number;
  @Input() mostrarTexto: boolean = true;
  @Input() mostrarIcone: boolean = true;
  @Input() texto = "Justificativa Renovação";



  public isLoading: boolean;
  public renovacaoEstudo: EstudoRenovacao;

  constructor(
    public dialog: MatDialog,
    private estudoRenovacaoService: EstudoRenovacaoService,
    private mensagem: MatSnackBar
  ) {}

  ngOnInit() {
    if (!this.idEstudo) {
      this.mensagem.open("Erro ao carregar estudo-renovacao-button. Estudo vazio.", "X", {
        duration: 5000
      });
    }else{
        this.isLoading = true;
    
        this.estudoRenovacaoService.houveAlteracao(this.idEstudo).subscribe((result: EstudoRenovacao) => {         
          if(result && result.id){
            this.renovacaoEstudo = result;
          }
          this.isLoading = false;
        });
      }
  }

  public abrirEstudo() {
    let dialogRef = this.dialog.open(EstudoRenovacaoDialogComponent, {
      width: "800px",
      height: "800px",
      data: this.renovacaoEstudo
    });
    let resultado: any;
    dialogRef.afterClosed().subscribe(result => {});
  }
}
